import CheckIcon from "@mui/icons-material/Check";
import {
  Box,
  CircularProgress,
  List,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";

import { MailAccount } from "api/memberPortal/mailList/mailList.types";

interface AddMemberListProps {
  isLoadingUsers: boolean;
  isFetching: boolean;
  selectedUsers: MailAccount[];
  onToggleUser: (_user: MailAccount) => void;
  hasSearchQuery: boolean;
  displayUsers: MailAccount[];
}

export default function AddMemberList({
  isLoadingUsers,
  isFetching,
  selectedUsers,
  onToggleUser,
  hasSearchQuery,
  displayUsers,
}: AddMemberListProps) {
  const isLoading = hasSearchQuery && (isLoadingUsers || isFetching);
  const showEmptyState =
    hasSearchQuery &&
    !isLoadingUsers &&
    !isFetching &&
    displayUsers.length === 0;
  const showResults =
    hasSearchQuery && !isLoadingUsers && !isFetching && displayUsers.length > 0;

  return (
    <Box
      sx={{
        maxHeight: 300,
        overflow: "auto",
        border: 1,
        borderColor: "divider",
        borderRadius: 2,
      }}
    >
      {!hasSearchQuery && (
        <Typography sx={{ p: 3, textAlign: "center" }} color="text.secondary">
          Search for users by name or email
        </Typography>
      )}

      {isLoading && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress size={24} />
        </Box>
      )}

      {showEmptyState && (
        <Typography sx={{ p: 2, textAlign: "center" }} color="text.secondary">
          No users found
        </Typography>
      )}

      {showResults && (
        <List disablePadding>
          {displayUsers.map((user) => {
            const selected = selectedUsers.some((u) => u.id === user.id);

            return (
              <ListItemButton
                key={user.id}
                onClick={() => onToggleUser(user)}
                selected={selected}
                sx={{
                  borderBottom: 1,
                  borderColor: "divider",
                  "&.Mui-selected": {
                    backgroundColor: "glyph.main",
                    "&:hover": {
                      backgroundColor: "glyph.dark",
                    },
                  },
                }}
              >
                <ListItemText
                  primary={
                    <Typography fontWeight="bold">{user.name}</Typography>
                  }
                  secondary={user.email}
                />
                {selected && <CheckIcon sx={{ color: "text.secondary" }} />}
              </ListItemButton>
            );
          })}
        </List>
      )}
    </Box>
  );
}
